import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import useApi from "../../../core/customhook/useApi";
import Swal from "sweetalert2";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { DatePicker } from "antd";
import dayjs from "dayjs";

const KraProfile = () => {
  const { financial_year } = useParams();
  const navigate = useNavigate();
  const pms_category_Id = localStorage.getItem("pms_category_id");
  const pms_category_Name = localStorage.getItem("pms_category_name");
  const [totalWaigthage, setTotalWaigthage] = useState(0);
  const [updateKra, setUpdateKra] = useState(false);
  const [allItemList, setAllItemList] = useState<any[]>([]);
  const [count, setCount] = useState(1);
  const [targetFields, setTargetFields] = useState<any>([""]);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [newItem, setNewItem] = useState<any>({
    kar_id: "",
    category_id: pms_category_Id || "",
    kra_category_name: "",
    kra_category_id: "",
    smart_goals: "",
    target_achievement_date: "",
    attachment_url: null,
    weightage: "",
    unit: "",
  });

  const getInputData = (e: any) => {
    const { name, value, files } = e.target;

    if (name === "attachment_url") {
      setNewItem((prev: any) => ({ ...prev, [name]: files[0] }));
      return;
    }

    if (name === "kra_category_id") {
      const selectedCategory = kraCategoryData?.data[0].categories.find(
        (item: any) => item.id === parseInt(value),
      );

      setNewItem((prev: any) => ({
        ...prev,
        kra_category_id: selectedCategory?.id || "",
        kra_category_name: selectedCategory?.kra_category || "",
      }));
      return;
    }

    setNewItem((prev: any) => ({ ...prev, [name]: value }));
  };

  const formatFinancialYear = (year: number) => {
    const nextYearShort = (year + 1).toString().slice(-2);
    return `${year}-${nextYearShort}`;
  };

  const handleTargetChange = (index: any, value: any) => {
    const newTargets = [...targetFields];
    newTargets[index] = value;
    setTargetFields(newTargets);
  };

  const addTargetField = () => {
    setTargetFields([...targetFields, ""]);
  };

  const removeTargetField = (index: number) => {
    const updated = targetFields.filter((_: any, i: any) => i !== index);
    setTargetFields(updated);
  };

  const getCurrentFinancialYear = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();
    const fyStart = month >= 3 ? year : year - 1;
    return formatFinancialYear(fyStart);
  };
  const [finance_year, setFinance_year] = useState(getCurrentFinancialYear());

  const {
    data: kraCategoryData,
    loading: kraCategoryLoading,
    error: kraCategoryError,
  } = useApi("/api/get-kra-category", {
    method: "POST",
    payload: {
      financial_year: financial_year,
    },
    autoCall: true,
  });

  const {
    data: viewKRAResponse,
    loading: viewKRALoading,
    error: viewKRAError,
  } = useApi("/api/manager/view-kra", {
    method: "POST",
    payload: {
      category_id: pms_category_Id || "",
      financial_year: financial_year,
    },
    autoCall: true,
    dependencies: [count],
  });

  useEffect(() => {
    if (viewKRAResponse?.success) {
      const items = viewKRAResponse?.data || [];
      setAllItemList(items);
      const total = items.reduce(
        (sum: number, item: any) => sum + Number(item.weightage || 0),
        0,
      );
      setTotalWaigthage(total);
    }
  }, [viewKRAResponse]);

  const {
    data: addKRAResponse,
    loading: addKRALoading,
    error: addKRAError,
    callApi: postKraData,
  } = useApi("/api/manager/add-kra", {
    method: "POST",
    autoCall: false,
  });

  const AddNewItem = async (e: any) => {
    e.preventDefault();
    const newWeightage = Number(newItem.weightage || 0);

    if (totalWaigthage + newWeightage > 100) {
      Swal.fire({
        title: "Error!",
        text: "Total weightage exceeds 100%. Please adjust the values.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }

    const formData = new FormData();
    formData.append("weightage", newItem.weightage);
    formData.append("category_id", pms_category_Id || "");
    formData.append("kra_category_name", newItem.kra_category_name || "");
    formData.append("kra_category_id", newItem.kra_category_id || "");
    formData.append("smart_goals", newItem.smart_goals);
    formData.append("target_achievement_date", newItem.target_achievement_date);
    formData.append("unit", newItem.unit);
    formData.append("target", JSON.stringify(targetFields));
    formData.append("attachment_url", newItem.attachment_url);
    formData.append("financial_year", financial_year || "");

    try {
      const response = await postKraData(formData);
      if (response?.success) {
        Swal.fire({
          title: "Success!",
          text: response?.message || "Category has been added successfully.",
          icon: "success",
          confirmButtonText: "OK",
        });
        setCount((prev) => prev + 1);
        setNewItem({
          smart_goals: "",
          target_achievement_date: "",
          kra_category_name: "",
          kra_category_id: "",
          attachment_url: null,
          weightage: "",
          unit: "",
        });

        // Reset file input
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }

        setTargetFields([""]);
      }
    } catch (error: any) {
      console.error("Error while adding :", error);
      Swal.fire({
        title: "Error!",
        text:
          error.response.data.message ||
          "There was a problem adding the category.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const {
    data: editKRAResponse,
    loading: editKRALoading,
    error: editKRAError,
    callApi: editKRA,
  } = useApi("/api/manager/edit-kra", {
    method: "POST",
    autoCall: false,
  });

  const UpdateItemData = async (e: any) => {
    e.preventDefault();

    const newWeightage = Number(newItem.weightage || 0);
    const oldGoal = allItemList.find((item) => item.kra_id === newItem.kra_id);
    const oldWeightage = Number(oldGoal?.weightage || 0);

    const adjustedTotal = totalWaigthage - oldWeightage + newWeightage;

    if (adjustedTotal > 100) {
      Swal.fire({
        title: "Error!",
        text: "Total weightage exceeds 100%. Please adjust the values.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }
    const formData = new FormData();
    formData.append("weightage", newItem.weightage);
    formData.append("category_id", pms_category_Id || "");
    formData.append("kra_id", newItem.kra_id || "");
    formData.append("kra_category_name", newItem.kra_category_name || "");
    formData.append("kra_category_id", newItem.kra_category_id || "");
    formData.append("smart_goals", newItem.smart_goals);
    formData.append("target_achievement_date", newItem.target_achievement_date);
    formData.append("unit", newItem.unit);
    formData.append("target", JSON.stringify(targetFields));
    formData.append("attachment_url", newItem.attachment_url);
    try {
      const response = await editKRA(formData);
      if (response.success) {
        Swal.fire({
          title: "Success!",
          text: response?.message || "KRA has been update successfully.",
          icon: "success",
          confirmButtonText: "OK",
        });
        setNewItem({
          smart_goals: "",
          target_achievement_date: "",
          kra_category_name: "",
          kra_category_id: "",
          attachment_url: null,
          weightage: "",
          unit: "",
        });

        // Reset file input
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }

        setTargetFields([""]);
        setUpdateKra(false);
        setCount((prev) => prev + 1);
      }
    } catch (error) {
      console.error("Error while updating :", error);
      Swal.fire({
        title: "Error!",
        text: "There was a problem adding the category.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const {
    data: deleteKRAResponse,
    loading: deleteKRALoading,
    error: deleteKRAError,
    callApi: deleteKRA,
  } = useApi("/api/manager/delete-kra", {
    method: "DELETE",
    autoCall: false,
  });

  const DeleteItem = async (ID: any) => {
    const confirmResult = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this KRA? This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    if (confirmResult.isConfirmed) {
      try {
        const response = await deleteKRA(
          undefined,
          "/api/manager/delete-kra/" + ID,
        );

        if (response.success) {
          Swal.fire({
            title: "Deleted!",
            text: response?.message || "KRA has been deleted successfully.",
            icon: "success",
            confirmButtonText: "OK",
          });
          setCount((prev) => prev + 1);
        }
      } catch (error) {
        console.error("Error while deleting:", error);
        Swal.fire({
          title: "Error!",
          text: "There was a problem deleting the category.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    }
  };

  // const parseTarget = (target: string | string[]) => {
  //   if (Array.isArray(target)) return target;
  //   try {
  //     return JSON.parse(target);
  //   } catch {
  //     return [];
  //   }
  // };

  const navigatetobehaviouralCompetency = () => {
    if (allItemList.length > 0 && totalWaigthage === 100) {
      navigate(`/pms-behavioural-Competence/${financial_year}`);
    } else if (allItemList.length < 0) {
      Swal.fire({
        title: "Warning!",
        text: "Atleast make a kra profile then you navigate the next step !",
        icon: "warning",
        confirmButtonText: "OK",
      });
    } else {
      Swal.fire({
        title: "Warning!",
        text: "KRA weightage is required to be exactly 100%.",
        icon: "warning",
        confirmButtonText: "OK",
      });
    }
  };

  const parseTarget = (target: any) => {
    try {
      if (!target) return [];
      return JSON.parse(target);
    } catch (e) {
      console.error("Error parsing target:", target);
      return [target]; // fallback
    }
  };

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Smart Goals</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Work & Operations</li>
                  <li className="breadcrumb-item">Goal Settings</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Smart Goals
                  </li>
                </ol>
              </nav>
            </div>
            <div className="head-icons ms-2">
              <CollapseHeader />
            </div>
          </div>

          {/* SMART Goals Form */}
          <div className="card mb-4">
            <div className="card-header">
              <h5>Define SMART Goal for {pms_category_Name}</h5>
            </div>
            <div className="card-body">
              <form>
                {/* SMART Goal Title */}
                <div className="mb-3">
                  <label className="form-label">
                    Category<sup className="text-danger">*</sup>
                  </label>
                  <select
                    className="form-control"
                    onChange={getInputData}
                    name="kra_category_id"
                    value={newItem.kra_category_id || ""}
                    required
                  >
                    <option value="">Select category</option>

                    {kraCategoryData?.data[0]?.categories?.map((item: any) => (
                      <option key={item.id} value={item.id}>
                        {item.kra_category}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="mb-3">
                  <label className="form-label">
                    SMART Goal Name<sup className="text-danger">*</sup>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    onChange={getInputData}
                    name="smart_goals"
                    value={newItem.smart_goals}
                    placeholder="Enter SMART goal name"
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">
                    Target<sup className="text-danger">*</sup>
                  </label>
                  {targetFields.map((target: any, index: number) => {
                    const isLast = index === targetFields.length - 1;
                    const isFirst = index === 0;

                    return (
                      <div
                        className="d-flex align-items-center mb-2"
                        key={index}
                      >
                        <div className="flex-grow-1">
                          <input
                            type="text"
                            className="form-control"
                            value={target}
                            onChange={(e) =>
                              handleTargetChange(index, e.target.value)
                            }
                            placeholder="Enter goal target"
                            required
                          />
                        </div>

                        {/* Delete button: show if not first OR if more than 1 */}
                        {!isLast && (
                          <button
                            type="button"
                            className="btn btn-outline-danger ms-2"
                            onClick={() => removeTargetField(index)}
                            title="Delete"
                          >
                            <i className="ti ti-trash"></i>
                          </button>
                        )}

                        {/* Add button: show only on the last field */}
                        {isLast && (
                          <button
                            type="button"
                            className="btn btn-outline-primary ms-2"
                            onClick={addTargetField}
                            title="Add"
                          >
                            ➕
                          </button>
                        )}
                      </div>
                    );
                  })}
                </div>
                {/* Dynamic Target Fields (Shown only when added) */}

                {/* Achievement Date */}
                <div className="mb-3">
                  <label className="form-label">
                    Target Achievement Date<sup className="text-danger">*</sup>
                  </label>
                  <input
                    type="text"
                    name="target_achievement_date"
                    id=""
                    required
                    className="form-control"
                    placeholder="Target Achievement Date"
                    onChange={getInputData}
                    value={newItem.target_achievement_date}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">
                    Unit<sup className="text-danger">*</sup>
                  </label>
                  <select
                    className="form-control"
                    onChange={getInputData}
                    name="unit"
                    value={newItem.unit}
                    required
                  >
                    <option>Select Unit</option>
                    <option value={"Percentage"}>Percentage</option>
                    <option value={"Number"}>Number</option>
                    <option value={"Time"}>Time</option>
                  </select>
                </div>
                <div className="mb-3">
                  <label className="form-label">
                    Weightage (%)<sup className="text-danger">*</sup>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    name="weightage"
                    placeholder="Enter weightage (e.g. 25)"
                    onChange={getInputData}
                    value={newItem.weightage}
                    min="0"
                    max="100"
                    required
                  />
                </div>
                {/* Achievement File */}
                <div className="mb-3">
                  <label className="form-label">
                    Upload File (.pdf, .jpg, .png)
                  </label>
                  <input
                    type="file"
                    className="form-control"
                    name="attachment_url"
                    ref={fileInputRef}
                    onChange={getInputData}
                    multiple
                  />
                </div>

                {/* Buttons */}
                <div className="d-flex justify-content-between">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={updateKra ? UpdateItemData : AddNewItem}
                    disabled={addKRALoading}
                  >
                    {addKRALoading
                      ? "Saving..."
                      : updateKra
                        ? "Update"
                        : "Save"}
                  </button>
                  <div className="d-flex gap-2">
                    <Link
                      to={`/pms-goals-profile-update/${financial_year}`}
                      type="button"
                      className="btn btn-outline-secondary"
                    >
                      <i className="bi bi-arrow-left ms-2"></i>Back
                    </Link>
                    <button
                      // to="/pms-behavioural-Competence"
                      type="button"
                      className="btn btn-secondary"
                      onClick={navigatetobehaviouralCompetency}
                    >
                      Next To Behavioural Competency
                      <i className="bi bi-arrow-right ms-2"></i>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>

          {/* SMART Goals Table */}
          {allItemList?.length > 0 && (
            <div className="card">
              <div className="card-header">
                <h5>Saved SMART Goals</h5>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-bordered table-hover">
                    <thead>
                      <tr>
                        <th>S No</th>
                        <th>KRA Category Name</th>
                        <th>SMART Goal</th>
                        <th>Target(s)</th>
                        <th>Achievement Date</th>
                        <th>File</th>
                        <th>Unit</th>
                        <th>Weightage (%)</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {allItemList?.map((goal: any, index: any) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{goal.kra_category_name || "N/A"}</td>
                          <td>{goal.smart_goals || "N/A"}</td>
                          <td>
                            <ul className="mb-0">
                              {parseTarget(goal.target).map(
                                (t: any, idx: any) => (
                                  <li key={idx}>
                                    {/* {idx + 1}.  */}
                                    {t}
                                  </li>
                                ),
                              )}
                            </ul>
                          </td>

                          <td>{goal.target_achievement_date}</td>
                          <td>
                            {!goal.attachment_url ||
                            goal.attachment_url.endsWith("/null") ? (
                              "N/A"
                            ) : (
                              <a
                                href={goal.attachment_url}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                View
                              </a>
                            )}
                          </td>
                          <td>{goal.unit || "N/A"}</td>
                          <td>{goal.weightage || "N/A"}</td>
                          <td>
                            <Link
                              to="#"
                              className="me-2"
                              onClick={() => {
                                setNewItem(goal);
                                setTargetFields(parseTarget(goal.target));
                                setUpdateKra(true);
                              }}
                              title="Edit"
                            >
                              <i className="ti ti-edit" />
                            </Link>

                            <Link
                              to="#"
                              className="text-danger"
                              onClick={() => DeleteItem(goal.kra_id)}
                              title="Delete"
                            >
                              <i className="ti ti-trash" />
                            </Link>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
        </div>
        {/* Footer */}
        <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
          <p className="mb-0">
            © {new Date().getFullYear()} WeConnect. All rights reserved.
          </p>
        </div>
      </div>
    </>
  );
};

export default KraProfile;
